import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import RenoLensVisualizer from '../components/RenoLensVisualizer';
import SEO from '../components/SEO';
import { Helmet } from 'react-helmet-async';

export default function Visualizer() {
  const visualizerSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Visualizer - Barcode Bites",
    "description": "Try our interactive visualizer to explore kitchen, bathroom, landscaping, and roofing options.",
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO />
      <Helmet>
        <title>Visualizer - Barcode Bites</title>
        <meta name="description" content="Try our interactive visualizer to explore kitchen, bathroom, landscaping, and roofing options." />
        <script type="application/ld+json">
          {JSON.stringify(visualizerSchema)}
        </script>
      </Helmet>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Visualizer
            </h1>
            <p className="text-lg text-gray-600">
              Explore our interactive visualizer to see how different options look in your space.
            </p>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 lg:p-8">
            <RenoLensVisualizer 
              height={800}
              industries={['kitchen-bath', 'landscaping', 'roofing', 'bathroom']}
              removeBranding={true}
              className="w-full"
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

